export default __webpack_public_path__ + "static/media/Bracers of the Wells of Night.cb2a91a9.jpg";